import { IUser } from '@/types/user'

export enum LocalStorageKeys {
  USER = 'transco-front-user',
  TOKEN = 'transco-front-token',
  PREV_LOCATION = 'transco-front-prev-location',
}

interface IAuthenticationData {
  token: string
  user: IUser | undefined
  prevLocation: any
}

export class AuthenticationLocalStorageService {

  private data: IAuthenticationData = {
    token: '',
    user: undefined,
    prevLocation: undefined,
  }

  get token(): string {
    this.data.token = this.data.token || this.getFromLocalStorage(LocalStorageKeys.TOKEN)

    return this.data.token
  }

  set token(token: string) {
    this.data.token = token || ''

    this.setFromLocalSorage(LocalStorageKeys.TOKEN, this.data.token)
  }

  get user(): IUser | undefined {
    this.data.user = this.data.user || this.getFromLocalStorage(LocalStorageKeys.USER, true)

    return this.data.user
  }

  set user(user: IUser | undefined) {
    this.data.user = user || undefined

    this.setFromLocalSorage(LocalStorageKeys.USER, this.data.user, true)
  }

  get prevLocation(): any {
    this.data.prevLocation = this.data.prevLocation || this.getFromLocalStorage(LocalStorageKeys.PREV_LOCATION, true)

    return this.data.prevLocation
  }

  set prevLocation(prevLocation: any) {
    this.data.prevLocation = prevLocation || undefined

    this.setFromLocalSorage(LocalStorageKeys.PREV_LOCATION, this.data.prevLocation, true)
  }

  public resetUser() {
    this.token = ''
    this.user = undefined
  }

  private getFromLocalStorage(key: LocalStorageKeys, isJson: boolean = false): any {
    const value = localStorage.getItem(key) || ''

    return isJson && value ? JSON.parse(value) : value
  }

  private setFromLocalSorage(key: LocalStorageKeys, value: any, isJson: boolean = false): void {
    if (value) {
      value = isJson ? JSON.stringify(value) : value
      localStorage.setItem(key, value)
    } else {
      localStorage.removeItem(key)
    }
  }
}

export default new AuthenticationLocalStorageService()
